import React from 'react'

const AgentProfile = () => {
  return (
    <div>AgentProfile</div>
  )
}

export default AgentProfile